import styles from './delete-catalog-dialog.module.scss';
import { useContext, useState } from 'react';
import { makeCourseRequest, useCourseGetRequestHook } from '../../../requestUtils';
import { Dialog, DialogActions, DialogContent, DialogTitle, GrayOutlinedButton, LoadingButton, SnackBarContext, Typography } from '@frontend-workspace/react-shared-lib';
import { ICatalogItem } from '../../../_models/catalog-item';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface DeleteCatalogDialogProps {
  onClose: () => void,
  open: boolean,
  refreshData: () => void,
  catalogId: string
}

export function DeleteCatalogDialog(props: DeleteCatalogDialogProps) {
  const { data: catalogItem }: { data: ICatalogItem } = useCourseGetRequestHook(`catalog/getItem/${props.catalogId}`, undefined);

  const { t } = useTranslation();
  const { setSnackbarMessage } = useContext(SnackBarContext);
  const [loading, setLoading] = useState<boolean>(false);

  const handleDeleteCatalog = () => {
    setLoading(true);
    makeCourseRequest(`catalog/delete/${props.catalogId}`, 'DELETE').then(result => {
      setSnackbarMessage({ content: t("deleteCatalog.deletedCourseFromCatalog"), type: "success" });
      setLoading(false);
      props.refreshData();
      props.onClose();
    }).catch(() => setSnackbarMessage({ content: t("deleteCatalog.couldNotDeleteCourseFromCatalog"), type: "error" }));
  };

  return (
    <Dialog
      open={props.open}
      maxWidth="sm"
      fullWidth>
      <DialogTitle className='mb-4'>
        {t("standard.areYouSureYouWantToDeleteCourse")}
      </DialogTitle>
      <DialogContent>
        <Typography
          component="div"
          variant='subtitle3'
          className='mb-3'>
          {catalogItem?.courseName}
        </Typography>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          variant="contained"
          size='large'
          color='error'
          onClick={handleDeleteCatalog}
          disabled={loading}
          loading={loading}
          className='minButtonWidth'>
          {loading ? '' : t("standard.delete")}
        </LoadingButton>
        <GrayOutlinedButton
          variant="outlined"
          size='large'
          onClick={props.onClose}
          className='minButtonWidth'>
          {t("standard.cancel")}
        </GrayOutlinedButton>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteCatalogDialog;
